export default __webpack_public_path__ + "static/media/hyperapp.fd4fbfc4.svg";